import { CANONICAL_SITE_URL } from "./part-indexability.js";

/** Keep every discovery surface on the same public origin, including previews. */
export function canonicalPageUrl(value: string): string {
  let source: URL;
  try {
    source = new URL(value, `${CANONICAL_SITE_URL}/`);
  } catch {
    return `${CANONICAL_SITE_URL}/`;
  }
  const pathname = source.pathname.replace(/\/+$/, "") || "/";
  const url = new URL(CANONICAL_SITE_URL);
  url.pathname = pathname;
  // Paginated collections are distinct pages. Tracking and search parameters
  // never belong in canonical URLs, but collapsing page 2 would hide its parts.
  const page = source.searchParams.get("page");
  if (/^\/manufacturers\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(pathname)
    && page && /^[1-9]\d{0,5}$/.test(page) && Number(page) > 1) {
    url.searchParams.set("page", page);
  }
  return url.toString();
}
